<main>
    <section class="layout-pt-lg layout-pb-lg bg-blue-2">
      <div class="container">
        <div class="row justify-center">
          <div class="col-xl-6 col-lg-7 col-md-9">
            <div class="px-50 py-50 sm:px-20 sm:py-20 bg-white shadow-4 rounded-4">
              <form [formGroup]="registerForm" (ngSubmit)="isStep1 ? sendVerificationCode() : verifyAndRegister()">
                <div class="row y-gap-20">
                  <div class="col-12">
                    <h1 class="text-22 fw-500">{{ isStep1 ? 'Hesap Oluştur' : 'Doğrulama Kodu' }}</h1>
                    <p class="mt-10">
                      <span *ngIf="isStep1">Hesabınız var mı? </span>
                      <a [routerLink]="['/login']" class="text-blue-1">Giriş Yap</a>
                    </p>
                  </div>

                  <!-- Hata Mesajları -->
                  <div class="col-12" *ngIf="errorMessage">
                    <div class="soft-alert">
                      <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="12"/><line x1="12" y1="16" x2="12.01" y2="16"/></svg>
                      <span>{{ errorMessage }}</span>
                    </div>
                  </div>

                  <!-- Başarı Mesajları -->
                  <div class="col-12" *ngIf="successMessage">
                    <div class="alert alert-success" style="background-color: #efe; color: #3c3; padding: 12px; border-radius: 4px; border: 1px solid #cfc;">
                      {{ successMessage }}
                    </div>
                  </div>

                  <!-- Ad (Sadece 1. adımda görünür) -->
                  <div class="col-12" *ngIf="isStep1">
                    <div class="form-input" [class.error]="firstName?.invalid && firstName?.touched">
                      <input 
                        type="text" 
                        formControlName="firstName"
                        [class.error]="firstName?.invalid && firstName?.touched">
                      <label class="lh-1 text-14 text-light-1">Adınız</label>
                    </div>
                    <div *ngIf="firstName?.invalid && firstName?.touched" class="text-12 text-red-1 mt-5">
                      Ad zorunludur.
                    </div>
                  </div>

                  <!-- Soyad (Sadece 1. adımda görünür) -->
                  <div class="col-12" *ngIf="isStep1">
                    <div class="form-input" [class.error]="lastName?.invalid && lastName?.touched">
                      <input 
                        type="text" 
                        formControlName="lastName"
                        [class.error]="lastName?.invalid && lastName?.touched">
                      <label class="lh-1 text-14 text-light-1">Soyadınız</label>
                    </div>
                    <div *ngIf="lastName?.invalid && lastName?.touched" class="text-12 text-red-1 mt-5">
                      Soyad zorunludur.
                    </div>
                  </div>

                  <!-- E-Posta (Sadece 1. adımda görünür) -->
                  <div class="col-12" *ngIf="isStep1">
                    <div class="form-input" [class.error]="email?.invalid && email?.touched">
                      <input 
                        type="email" 
                        formControlName="email"
                        [class.error]="email?.invalid && email?.touched">
                      <label class="lh-1 text-14 text-light-1">E-Posta</label>
                    </div>
                    <div *ngIf="email?.invalid && email?.touched" class="text-12 text-red-1 mt-5">
                      <span *ngIf="email?.errors?.['required']">E-posta zorunludur.</span>
                      <span *ngIf="email?.errors?.['email']">Geçerli bir e-posta adresi girin.</span>
                    </div>
                  </div>

                  <!-- Telefon Numarası (Sadece 1. adımda görünür) -->
                  <div class="col-12" *ngIf="isStep1">
                    <div class="form-input" [class.error]="phoneNumber?.invalid && phoneNumber?.touched">
                      <input 
                        type="tel" 
                        formControlName="phoneNumber"
                        placeholder="+905551234567"
                        [class.error]="phoneNumber?.invalid && phoneNumber?.touched">
                      <label class="lh-1 text-14 text-light-1">Telefon Numarası</label>
                    </div>
                    <div *ngIf="phoneNumber?.invalid && phoneNumber?.touched" class="text-12 text-red-1 mt-5">
                      <span *ngIf="phoneNumber?.errors?.['required']">Telefon numarası zorunludur.</span>
                      <span *ngIf="phoneNumber?.errors?.['pattern']">Geçerli bir telefon numarası girin (örn: +905551234567 veya 05551234567).</span>
                    </div>
                  </div>

                  <!-- Şifre (Sadece 1. adımda görünür) -->
                  <div class="col-12" *ngIf="isStep1">
                    <div class="form-input" [class.error]="password?.invalid && password?.touched">
                      <input 
                        type="password" 
                        formControlName="password"
                        [class.error]="password?.invalid && password?.touched">
                      <label class="lh-1 text-14 text-light-1">Şifre</label>
                    </div>
                    <div *ngIf="password?.invalid && password?.touched" class="text-12 text-red-1 mt-5">
                      <span *ngIf="password?.errors?.['required']">Şifre zorunludur.</span>
                      <span *ngIf="password?.errors?.['minlength']">Şifre en az 6 karakter olmalıdır.</span>
                    </div>
                  </div>

                  <!-- Şifre Tekrarı (Sadece 1. adımda görünür) -->
                  <div class="col-12" *ngIf="isStep1">
                    <div class="form-input" [class.error]="(passwordConfirm?.invalid && passwordConfirm?.touched) || passwordConfirm?.errors?.['passwordMismatch']">
                      <input 
                        type="password" 
                        formControlName="passwordConfirm"
                        [class.error]="(passwordConfirm?.invalid && passwordConfirm?.touched) || passwordConfirm?.errors?.['passwordMismatch']">
                      <label class="lh-1 text-14 text-light-1">Şifre Tekrarı</label>
                    </div>
                    <div *ngIf="passwordConfirm?.errors?.['passwordMismatch'] && passwordConfirm?.touched" class="text-12 text-red-1 mt-5">
                      Şifreler eşleşmiyor.
                    </div>
                    <div *ngIf="passwordConfirm?.invalid && passwordConfirm?.touched && !passwordConfirm?.errors?.['passwordMismatch']" class="text-12 text-red-1 mt-5">
                      Şifre tekrarı zorunludur.
                    </div>
                  </div>

                  <!-- Doğrulama Kodu (Sadece 2. adımda görünür) -->
                  <div class="col-12" *ngIf="!isStep1">
                    <p class="text-16 text-light-1 mb-20">
                      <strong>{{ email?.value }}</strong> adresine gönderilen doğrulama kodunu girin.
                    </p>
                    <div class="form-input" [class.error]="code?.invalid && code?.touched">
                      <input 
                        type="text" 
                        formControlName="code"
                        placeholder="123456"
                        maxlength="6"
                        [class.error]="code?.invalid && code?.touched">
                      <label class="lh-1 text-14 text-light-1">Doğrulama Kodu (6 haneli)</label>
                    </div>
                    <div *ngIf="code?.invalid && code?.touched" class="text-12 text-red-1 mt-5">
                      <span *ngIf="code?.errors?.['required']">Doğrulama kodu zorunludur.</span>
                      <span *ngIf="code?.errors?.['pattern']">Doğrulama kodu 6 haneli olmalıdır.</span>
                    </div>
                    <p class="text-14 text-light-1 mt-10">
                      E-posta adresinize gönderilen 6 haneli doğrulama kodunu girin.
                    </p>
                  </div>

                  <!-- Newsletter Checkbox -->
                  <div class="col-12" *ngIf="isStep1">
                    <div class="d-flex">
                      <div class="form-checkbox mt-5">
                        <input type="checkbox" formControlName="newsletter">
                        <div class="form-checkbox__mark">
                          <div class="form-checkbox__icon icon-check"></div>
                        </div>
                      </div>
                      <div class="text-15 lh-15 text-light-1 ml-10">E-Posta adresinize özel teklifler gönderilecektir. Gizlilik Politikasında belirtilen şekilde daha sonra iptal edebilirsiniz.</div>
                    </div>
                  </div>

                  <!-- Butonlar -->
                  <div class="col-12" style="margin-top: 20px;">
                    <app-loading *ngIf="isLoading" [size]="'small'" [message]="isStep1 ? 'Kod gönderiliyor...' : 'Kayıt işlemi yapılıyor...'"></app-loading>
                    <button
                      *ngIf="!isLoading"
                      type="submit"
                      class="button py-20 -dark-1 bg-blue-1 text-white col-12"
                      style="width: 100%; display: flex; align-items: center; justify-content: center;">
                      <span style="display: flex; align-items: center; justify-content: center;">
                        {{ isStep1 ? 'Kayıt İçin İlerle' : 'Kayıt Ol' }}
                        <div class="icon-arrow-top-right ml-15"></div>
                      </span>
                    </button>
                  </div>

                  <!-- Geri Dön Butonu (2. adımda) -->
                  <div class="col-12" *ngIf="!isStep1">
                    <button 
                      type="button"
                      class="button py-15 -outline-blue-1 text-blue-1 col-12"
                      style="width: 100%;"
                      (click)="goBackToStep1()"
                      [disabled]="isLoading">
                      Geri Dön
                    </button>
                  </div>
                </div>
              </form>

              <!-- Sosyal Medya Girişleri (Sadece 1. adımda göster) -->
              <div class="row y-gap-20 pt-30" *ngIf="isStep1">
                <div class="col-12">
                  <div class="text-center">veya kayıt olmak için</div>

                  <!-- Google Sign-In Button Container -->
                  <div id="googleSignInButtonRegister" class="mt-15" style="display: flex; justify-content: center; width: 100%;"></div>
                </div>

                <div class="col-12">
                  <div class="text-center px-30">Kayıt olmakla Pusula Tatil Kullanım Koşulları ve Gizlilik Politikasını kabul ediyorsunuz.</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </main>